// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"828":"6014e6a9","992":"630a76de"}[chunkId] + ".chunk.js";
};